export default __webpack_public_path__ + "static/media/BeeksFC.c03e901f.png";